<template>
    <div>
        <b-row>
            <csp-desktop-firm-configurable-documents :cols="12" :context-id="1" context-type="reseller"
                :form-context="dummyFormContext"/>
        </b-row>
    </div>
</template>

<script>
    import FirmConfigurableDocuments from '@desktop/components/FirmConfigurableDocuments.vue';
    import FormContext from '@desktop/components/FormContext';

    export default {
        name: 'ResellerDocuments',
        components: {
            'csp-desktop-firm-configurable-documents': FirmConfigurableDocuments,
        },
        data() {
            return {
                // this form context only exists so that the form will render
                dummyFormContext: new FormContext({
                    name: 'resellerDocuments',
                    isLoaded: true,
                }),
            }
        },
    }
</script>
